import i18n from 'i18n';

const SessionExpiredError = new Error();
SessionExpiredError.name = 'SessionExpiredError';
SessionExpiredError.message = i18n.t('common:errors.sessionExpiredError');

const NoSessionError = new Error();
NoSessionError.name = 'NoSessionError';
NoSessionError.message = i18n.t('common:errors.noSessionError');

const LoadDataError = new Error();
LoadDataError.name = 'LoadDataError';
LoadDataError.message = i18n.t('common:errors.loadDataError');

export { SessionExpiredError, NoSessionError, LoadDataError };



// WEBPACK FOOTER //
// ./src/constants/errors.js